import { object, string } from "yup";

export const contactUsValidation = (t) =>
  object().shape({
    name: string().required(t("nameRequired")),
    email: string().email(t("notValidEmail")).required(t("emailRequired")),
    telephone: string()
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t("telephoneError1"))
      .matches(/^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t("telephoneError2"))
      .min(9)
      .max(9)
      .required(t("TelephoneRequired")),
    subject: string().required(t("subjectRequired")),
    subsubject: string().required(t("about_subjectRequired")),
    comment: string().required(t("commentRequired")),
  });
